import { createCloudRunAxios } from './axios';
import { pauseFlow, resumeFlow, archiveFlow, activateFlow } from './remiApi';
import { useOrganizationStore } from '../stores/useOrganizationStore';

const remiApi = createCloudRunAxios('remi-api');

export interface GenerateVoicemailResponse {
  voicemail?: string;
  queued?: boolean;
  request_id?: string;
  organization_id?: string;
  endpoint?: string;
  success?: boolean;
}

export const generateVoicemail = async (description: string): Promise<GenerateVoicemailResponse> => {
  try {
    const organizationId = useOrganizationStore.getState().organization?.id ?? '';
    const response = await remiApi.post('/api/v1/voicemail-generator', { description, organization_id: organizationId });
    return response.data;
  } catch (error) {
    console.error('Error generating voicemail:', error);
    throw error;
  }
};

export const createFlowExecutions = async (flowId: string) => {
  try {
    return await activateFlow(flowId);
  } catch (error) {
    console.error('Error activating flow:', error);
    throw error;
  }
};

export const archiveFlows = async (flowId: string) => {
  try {
    return await archiveFlow(flowId);
  } catch (error) {
    console.error('Error archiving flow:', error);
    throw error;
  }
};

export const pauseScheduledFlow = async (flowId: string) => {
  try {
    return await pauseFlow(flowId);
  } catch (error) {
    console.error('Error pausing scheduled flow:', error);
    throw error;
  }
};

export const pauseActiveFlow = async (flowId: string) => {
  try {
    return await pauseFlow(flowId);
  } catch (error) {
    console.error('Error pausing active flow:', error);
    throw error;
  }
};

// testCall moved to api/flowWorker.ts - uses FlowWorker /execute endpoint instead of /callBuilder

export const resumePausedFlows = async (flowId: string) => {
  try {
    return await resumeFlow(flowId);
  } catch (error) {
    console.error('Error resuming paused flow:', error);
    throw error;
  }
};

export const addContactsToFlow = async (flowId: string, orgId: string, tag: string[]) => {
  try {
    const response = await remiApi.post(`/api/v1/flows/${flowId}/contacts/bulk`, {
      tags: tag,
      organization_id: orgId,
    });
    return response.data;
  } catch (error) {
    console.error('Error adding contacts to flow:', error);
    throw error;
  }
};

export const improveText = async (text: string, instructions: string) => {
  try {
    const organizationId = useOrganizationStore.getState().organization?.id ?? '';
    const response = await remiApi.post('/api/v1/text/improve', {
      organization_id: organizationId,
      text,
      instructions,
    });
    return { improved_text: response.data?.improved_text ?? '' };
  } catch (error) {
    console.error('Error improving text:', error);
    throw error;
  }
};
